import { Element } from 'slate';
import { StyledDataSheet } from '../../components';
export const isReferenceTable = (node) => Element.isElement(node) && node.type === 'reference-table';

const referenceTable =
  (options = {}) =>
  (editor) => {
    const { renderElement, isVoid } = editor;
    editor.isVoid = (element) => isReferenceTable(element) || isVoid(element);

    editor.renderElement = (props) => {
      if (isReferenceTable(props.element)) {
        return <StyledDataSheet {...props} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default referenceTable;
